<template>
  <div class="bg-white px-5">
    <h3 class="text-left pa-3 ma-3">Ingreso variable</h3>
    <div class="d-flex justify-space-around">
      <k-p-i-card
        :title="`Presupuesto del periodo de pago`"
        :value="currentWeek?.estimate ?? 0"
        icon="star"
        icon-driver="local"
        :loading="isLoading"
        format="currency"
        class="w-25"
      />
      <k-p-i-card
        title="Facturación de periodo de pago"
        :value="currentWeek?.billing ?? 0"
        icon="money"
        format="currency"
        icon-driver="local"
        :loading="isLoading"
        class="w-25"
      />
      <k-p-i-card
        title="Logro de periodo de pago "
        :value="`${formatFloat(currentWeek?.financialAchievement ?? 0, 0)}`"
        format="percentage"
        icon="certificate"
        icon-driver="local"
        class="w-25"
        :loading="isLoading"
        :value-class="
          currentWeek?.financialAchievement > 100 ? 'text-success' : ''
        "
      />
    </div>

    <week-slider
      :username="username"
      class="w-90"
      @update:week="onWeekChanged"
    />
    <v-row>
      <v-col v-if="commissions.data.weeks" cols="12">
        <span v-if="!isLoading" class="text-primary d-flex">
          {{ currentWeek.interval }}. Ppto. Semana {{ currentWeek.week }}
        </span>
        <weekly-budget-table
          :data="commissions.data"
          :loading="isLoading"
          class="mb-3 px-3"
        />
      </v-col>
      <v-col cols="12" md="6">
        <weekly-earnings-donut
          class="pa-0"
          :data="commissions.data"
          :loading="isLoading"
        />
      </v-col>
      <v-col cols="12" md="6">
        <weekly-earnings-graph
          class="pa-0"
          :data="commissions.data"
          :loading="isLoading"
        />
      </v-col>
    </v-row>
    <div class="text-left text-dark font-weight-bold mb-3 pa-2">
      Nota: El ingreso variable se calcula con base en el periodo de pagos
      semanales. Los importes aquí mostrados pueden diferir de la facturación
      mensual calendario publicado en otras vistas de IEL.
    </div>
    <confidentiality-notice />
  </div>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex';
  import moment from 'moment';
  import axios from '@/plugins/axios';
  import { Roles } from '@/core/constants/roleConstants';
  import numbersFormats from '@/mixins/numbersFormats';
  import DateFormats from '@/core/constants/DateFormats';
  import KPICard from '@/components/cards/KPICard.vue';
  import WeekSlider from './components/WeekSlider.vue';
  import WeeklyEarningsGraph from './components/WeeklyEarningsGraph.vue';
  import WeeklyEarningsDonut from './components/WeeklyEarningsDonut.vue';
  import WeeklyBudgetTable from './components/WeeklyBudgetTable.vue';
  import ConfidentialityNotice from '@/components/ConfidentialityNotice.vue';

  export default {
    name: 'WeeklyEarnings',
    components: {
      KPICard,
      WeekSlider,
      WeeklyEarningsGraph,
      WeeklyEarningsDonut,
      WeeklyBudgetTable,
      ConfidentialityNotice,
    },
    mixins: [numbersFormats],
    data() {
      return {
        commissions: {
          data: {},
          loading: false,
          error: '',
        },
        currentWeek: {},
      };
    },
    computed: {
      ...mapGetters({
        user: 'auth/user',
      }),
      isLoading() {
        return this.commissions.loading;
      },
    },
    created() {
      this.username = this.resolveUsername();
      this.activeLoader();
    },
    methods: {
      ...mapActions('loader', ['activeLoader', 'desactiveLoader']),
      onWeekChanged(date) {
        this.currentWeek = date;
        const targetWeek = this.lastMonths(date.range.startDateFetchFormat);
        const params = {
          week: date.weekYear,
          end_date: date.yearMonth,
          start_date: targetWeek,
          role: Roles.SELLER,
          channel: this.user.VTWEG,
          user: this.username,
        };
        this.fetchCommissions(params);
      },
      resolveUsername() {
        return this.$getLocalStorageSeller() !== null
          ? this.$getLocalStorageSeller()
          : this.fillNumberToNDigits(this.user.sap_id, 8);
      },
      async fetchCommissions(params) {
        try {
          this.commissions.loading = true;
          this.commissions.error = '';
          const res = await axios.post('/earnings/weekly-commissions', params);
          this.commissions.data = res.data;
        } catch (error) {
          this.$toast.warning('No se pudieron cargar las semanas disponibles');
        }
        this.desactiveLoader();
        this.commissions.loading = false;
      },
      lastMonths(startDate, format = 'YYYY-MM-DD', months = 6) {
        const newDate = moment(startDate, format);
        const targetDate = newDate.clone().subtract(months, 'months');
        return `${targetDate.format(DateFormats.YEAR_MONTH)}`;
      },
    },
  };
</script>
